module.exports = __webpack_public_path__ + "img/sankaku_24_red.dc015f53.png";